{
  "status": {
    "PROBATION": "تحت التجربة",
    "ACTIVE": "على رأس العمل",
    "SUSPENDED": "موقوف",
    "ENDED": "منتهية خدمته"
  },
  "listStatus": {
    "CURRENT": "الموظفون الحاليون",
    "ALL": "كل الحالات",
    "PROBATION": "تحت التجربة",
    "ACTIVE": "على رأس العمل",
    "SUSPENDED": "موقوفون",
    "ENDED": "منتهية خدمتهم"
  },
  "nationalityClass": {
    "OMANI": "عماني",
    "NON_OMANI": "غير عماني"
  },
  "nationality": {
    "common": "الجنسيات الشائعة",
    "all": "كل الدول"
  },
  "gender": {
    "MALE": "ذكر",
    "FEMALE": "أنثى"
  },
  "marital": {
    "SINGLE": "أعزب",
    "MARRIED": "متزوج",
    "DIVORCED": "مطلق",
    "WIDOWED": "أرمل"
  },
  "payMethod": {
    "BANK": "تحويل بنكي (حماية الأجور)",
    "CASH": "نقدًا",
    "CHEQUE": "شيك"
  },
  "contractType": {
    "UNLIMITED": "غير محدد المدة",
    "FIXED_TERM": "محدد المدة",
    "PART_TIME": "دوام جزئي",
    "TEMPORARY": "مؤقت"
  },
  "endReason": {
    "RESIGNATION": "استقالة",
    "TERMINATION": "فصل",
    "END_OF_CONTRACT": "انتهاء العقد",
    "FAILED_PROBATION": "عدم اجتياز فترة التجربة",
    "RETIREMENT": "تقاعد",
    "DEATH": "وفاة",
    "OTHER": "سبب آخر"
  },
  "salaryReason": {
    "HIRE": "التعيين",
    "INCREMENT": "علاوة",
    "PROMOTION": "ترقية",
    "ADJUSTMENT": "تعديل",
    "CORRECTION": "تصحيح"
  },
  "documentType": {
    "CIVIL_ID": "البطاقة المدنية",
    "RESIDENT_CARD": "بطاقة الإقامة",
    "PASSPORT": "جواز السفر",
    "VISA": "التأشيرة",
    "WORK_PERMIT": "تصريح العمل",
    "DRIVING_LICENCE": "رخصة القيادة",
    "HEALTH_CARD": "البطاقة الصحية",
    "CONTRACT": "العقد",
    "CERTIFICATE": "شهادة",
    "OTHER": "أخرى"
  },
  "documentStatus": {
    "ACTIVE": "سارية",
    "CANCELLED": "ملغاة"
  },
  "expiryBucket": {
    "EXPIRED": "منتهية",
    "D7": "تنتهي خلال 7 أيام",
    "D30": "تنتهي خلال 30 يومًا",
    "D90": "تنتهي خلال 90 يومًا"
  },
  "expiryWithin": {
    "EXPIRED": "المنتهية فقط",
    "D7": "المنتهية أو خلال 7 أيام",
    "D30": "المنتهية أو خلال 30 يومًا",
    "D90": "المنتهية أو خلال 90 يومًا"
  },
  "expiry": {
    "today": "تنتهي اليوم",
    "in_zero": "تنتهي اليوم",
    "in_one": "تنتهي خلال يوم واحد",
    "in_two": "تنتهي خلال يومين",
    "in_few": "تنتهي خلال {{n}} أيام",
    "in_many": "تنتهي خلال {{n}} يومًا",
    "in_other": "تنتهي خلال {{n}} يوم",
    "ago_zero": "انتهت اليوم",
    "ago_one": "انتهت منذ يوم واحد",
    "ago_two": "انتهت منذ يومين",
    "ago_few": "انتهت منذ {{n}} أيام",
    "ago_many": "انتهت منذ {{n}} يومًا",
    "ago_other": "انتهت منذ {{n}} يوم"
  },
  "kind": {
    "EARNING": "استحقاق",
    "DEDUCTION": "استقطاع"
  },
  "componentType": {
    "FIXED": "ثابت",
    "VARIABLE": "متغير"
  },
  "componentTypeHint": {
    "FIXED": "جزء من الراتب يُصرف كل شهر.",
    "VARIABLE": "يُدخل في كشف الرواتب عند استحقاقه (مكافأة، استرداد سلفة)."
  },
  "dashboard": {
    "title": "الموارد البشرية",
    "subtitle": "القوى العاملة اليوم: من على رأس العمل، والوثائق المستحقة، وما ينتهي قريبًا",
    "links": {
      "employees": "الموظفون",
      "documents": "انتهاء الوثائق"
    },
    "figures": "أرقام القوى العاملة",
    "headcount": "عدد الموظفين",
    "headcountDetail": "كل من لم تنتهِ خدمته",
    "omani": "العمانيون",
    "omanisation": "نسبة التعمين {{percent}}%",
    "nonOmani": "غير العمانيين",
    "joiners": "المعيّنون",
    "leavers": "المغادرون",
    "thisMonth": "هذا الشهر",
    "earnings": "الاستحقاقات الشهرية",
    "earningsDetail": "الرواتب الحالية قبل الاستقطاعات",
    "byStatus": "حسب الحالة",
    "expiring": "وثائق قاربت على الانتهاء",
    "expiringEmpty": "لا تنتهي أي وثيقة خلال 90 يومًا.",
    "seeAll": "عرض الكل",
    "probation": "فترات تجربة تنتهي خلال 30 يومًا",
    "probationEmpty": "لا تنتهي أي فترة تجربة قريبًا.",
    "contractsEnding": "عقود محددة المدة تنتهي خلال 60 يومًا",
    "contractsEndingEmpty": "لا ينتهي أي عقد محدد المدة قريبًا.",
    "byUnit": "حسب الوحدة التنظيمية",
    "noUnit": "بلا وحدة",
    "byNationality": "حسب الجنسية",
    "nobody": "لا يوجد موظفون بعد."
  },
  "setup": {
    "title": "أعدّ هيكل الرواتب أولًا",
    "body": "يتطلب التعيين عنصر الراتب الأساسي. حمّل العناصر العمانية المعتادة (الأساسي والسكن والنقل والاستقطاعات المعتادة) ثم عدّلها حسب حاجتك.",
    "bodyReader": "يتطلب التعيين عنصر الراتب الأساسي. اطلب ممن يعدّ عناصر الراتب تحميلها."
  },
  "employees": {
    "title": "الموظفون",
    "subtitle": "ملف الموظفين: العاملون ووظائفهم ووثائقهم",
    "hire": "تعيين موظف",
    "searchPlaceholder": "الرقم أو الاسم أو الرقم المدني",
    "searchLabel": "البحث في الموظفين",
    "clearSearch": "مسح البحث",
    "documentsDue_zero": "لا وثائق مستحقة",
    "documentsDue_one": "وثيقة واحدة مستحقة",
    "documentsDue_two": "وثيقتان مستحقتان",
    "documentsDue_few": "{{n}} وثائق مستحقة",
    "documentsDue_many": "{{n}} وثيقة مستحقة",
    "documentsDue_other": "{{n}} وثيقة مستحقة",
    "fields": {
      "number": "الرقم",
      "name": "الموظف",
      "orgUnit": "الوحدة التنظيمية",
      "nationality": "الجنسية",
      "hireDate": "تاريخ التعيين",
      "documentsDue": "الوثائق",
      "monthlyGross": "إجمالي الراتب الشهري",
      "status": "الحالة"
    },
    "filters": {
      "status": "الحالة",
      "nationality": "الجنسية",
      "anyNationality": "العمانيون وغير العمانيين",
      "orgUnit": "الوحدة التنظيمية",
      "allUnits": "كل الوحدات"
    },
    "empty": {
      "title": "لا يوجد موظفون بعد",
      "body": "عيّن أول موظف لبدء ملف الموظفين.",
      "filteredTitle": "لا يوجد موظف مطابق",
      "filteredBody": "غيّر البحث أو عوامل التصفية."
    }
  },
  "hire": {
    "title": "تعيين موظف",
    "subtitle": "الشخص والوظيفة والعقد والراتب دفعة واحدة",
    "submit": "تعيين الموظف",
    "toast": "عُيّن {{name}} برقم {{number}}"
  },
  "edit": {
    "title": "تعديل بيانات الموظف",
    "submit": "حفظ التغييرات",
    "toast": "حُفظت بيانات {{name}}"
  },
  "form": {
    "sections": {
      "personal": "البيانات الشخصية",
      "contact": "التواصل",
      "job": "الوظيفة",
      "contract": "العقد",
      "salary": "الراتب",
      "bank": "طريقة صرف الراتب"
    },
    "firstName": "الاسم الأول",
    "middleName": "الاسم الأوسط",
    "lastName": "اسم العائلة",
    "nameAr": "الاسم الكامل بالعربية",
    "nameArHint": "كما هو في البطاقة المدنية أو بطاقة الإقامة.",
    "gender": "الجنس",
    "birthDate": "تاريخ الميلاد",
    "maritalStatus": "الحالة الاجتماعية",
    "notGiven": "غير محدد",
    "nationality": "الجنسية",
    "nationalityPlaceholder": "اختر الجنسية",
    "nationalitySearch": "ابحث عن دولة",
    "nationalityEmpty": "لم يُعثر على دولة",
    "civilNumber": "رقم البطاقة المدنية / الإقامة",
    "civilNumberHint": "يُعرَّف به الموظف في ملف حماية الأجور.",
    "passportNumber": "رقم جواز السفر",
    "spfNumber": "رقم صندوق الحماية الاجتماعية",
    "spfNumberHint": "رقم التأمين للموظفين العمانيين.",
    "spfExempt": "معفى من اشتراكات الحماية الاجتماعية",
    "spfExemptHint": "لا ينطبق عليه أي بند اشتراك (مثل متقاعد أعيد توظيفه).",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "address": "العنوان",
    "emergencyName": "جهة الاتصال في الطوارئ",
    "emergencyPhone": "هاتف جهة الاتصال في الطوارئ",
    "jobTitle": "المسمى الوظيفي",
    "jobTitleAr": "المسمى الوظيفي بالعربية",
    "orgUnit": "الوحدة التنظيمية",
    "orgUnitPlaceholder": "اختر الوحدة التنظيمية",
    "noUnit": "بلا وحدة",
    "hireDate": "تاريخ التعيين",
    "hireDateHint": "أول يوم عمل: يبدأ منه العقد والراتب ومدة الخدمة.",
    "salaryHint": "المبلغ الشهري لكل عنصر ثابت. الراتب الأساسي مطلوب.",
    "bankHint": "يُدرج البنك ورقم الآيبان في ملف حماية الأجور.",
    "payMethod": "طريقة الصرف",
    "bankCode": "رمز البنك",
    "bankCodeHint": "الرمز المختصر للبنك أو رمز السويفت، مثل BMUSOMRX.",
    "iban": "رقم الآيبان أو الحساب",
    "choose": "اختر…",
    "fix": "بعض الحقول تحتاج إلى مراجعة.",
    "notSaved": "لم يُحفظ",
    "user": "حساب الدخول",
    "userHint": "يربط ما يستحقه المستخدم (العمولات والحوافز) برواتب هذا الموظف.",
    "noUser": "بلا حساب دخول"
  },
  "contract": {
    "type": "نوع العقد",
    "startDate": "يبدأ في",
    "endDate": "ينتهي في",
    "endDateFixed": "العقد محدد المدة يحتاج إلى تاريخ انتهاء.",
    "endDateHint": "اتركه فارغًا لعقد غير محدد المدة.",
    "probationMonths": "فترة التجربة (بالأشهر)",
    "probationHint": "ثلاثة أشهر افتراضيًا، وبحد أقصى {{max}}.",
    "probationUntil": "{{months}} أشهر حتى {{date}}",
    "noticeDays": "مدة الإشعار (بالأيام)",
    "weeklyHours": "ساعات العمل الأسبوعية",
    "note": "ملاحظة",
    "currentTitle": "العقد الحالي",
    "none": "لا يوجد عقد في الملف.",
    "openEnded": "غير محدد",
    "newVersion": "إصدار جديد للعقد",
    "newTitle": "إصدار جديد للعقد",
    "newBody": "يبقى العقد الحالي كما هو ويحل محله الإصدار الجديد من تاريخ بدئه.",
    "newConfirm": "حفظ الإصدار الجديد",
    "toast": "حُفظ الإصدار الجديد للعقد",
    "versions": "إصدارات العقد",
    "version": "الإصدار",
    "current": "الحالي",
    "period": "المدة"
  },
  "salary": {
    "currentTitle": "الراتب الحالي",
    "since": "ساري منذ {{date}}",
    "none": "لا يوجد راتب في الملف.",
    "change": "تغيير الراتب",
    "changeTitle": "تغيير الراتب",
    "changeBody": "راتب جديد من تاريخ محدد؛ تبقى الرواتب السابقة كما هي ويحتسب كشف الرواتب كل جزء بنسبته.",
    "changeConfirm": "حفظ الراتب الجديد",
    "toast": "حُفظ الراتب الجديد",
    "effectiveFrom": "يسري من",
    "reason": "السبب",
    "note": "ملاحظة",
    "history": "سجل الرواتب",
    "current": "الحالي",
    "by": "سجّله",
    "component": "العنصر",
    "amount": "المبلغ الشهري",
    "totalEarnings": "إجمالي الاستحقاقات",
    "totalDeductions": "إجمالي الاستقطاعات",
    "noBasicTitle": "لا يوجد عنصر الراتب الأساسي",
    "noBasicBody": "يحتاج الراتب إلى عنصر الراتب الأساسي. حمّل العناصر المعتادة من صفحة عناصر الراتب أولًا.",
    "openComponents": "فتح عناصر الراتب"
  },
  "employee": {
    "title": "الموظف",
    "backToList": "العودة إلى الموظفين",
    "since": "منذ {{date}} · {{years}} سنة خدمة",
    "probationEnds": "تنتهي فترة التجربة في {{date}}",
    "suspendedTitle": "موقوف: لا يُصرف له راتب طوال مدة الإيقاف",
    "endedTitle": "انتهت الخدمة في {{date}} ({{reason}})",
    "actions": {
      "confirmProbation": "تثبيت بعد التجربة",
      "reinstate": "إعادة إلى العمل",
      "edit": "تعديل",
      "suspend": "إيقاف",
      "end": "إنهاء الخدمة"
    }
  },
  "tabs": {
    "label": "ملف الموظف",
    "overview": "نظرة عامة",
    "contract": "العقد",
    "salary": "الراتب",
    "documents": "الوثائق",
    "files": "الملفات",
    "payslips": "قسائم الرواتب",
    "history": "السجل"
  },
  "overview": {
    "nameEn": "الاسم بالإنجليزية",
    "spfExempt": "معفى من اشتراكات الحماية الاجتماعية",
    "serviceYears": "مدة الخدمة",
    "years": "{{years}} سنة",
    "probationEnd": "نهاية فترة التجربة",
    "yes": "نعم",
    "no": "لا"
  },
  "confirmProbation": {
    "title": "تثبيت {{name}} بعد فترة التجربة؟",
    "body": "يصبح الموظف على رأس العمل وتُغلق فترة التجربة.",
    "confirm": "تثبيت",
    "toast": "ثُبّت {{name}}"
  },
  "reinstate": {
    "title": "إعادة {{name}} إلى العمل؟",
    "body": "ينتهي الإيقاف ويعود صرف راتبه في كشف الرواتب.",
    "confirm": "إعادة إلى العمل",
    "toast": "أعيد {{name}} إلى العمل"
  },
  "suspend": {
    "title": "إيقاف {{name}}",
    "body": "لا يُصرف للموظف راتب طوال مدة الإيقاف، ويبقى ملفه ووثائقه كما هي.",
    "reason": "السبب",
    "confirm": "إيقاف",
    "toast": "أوقف {{name}}"
  },
  "end": {
    "title": "إنهاء خدمة {{name}}",
    "body": "يُصرف راتبه حتى آخر يوم عمل، وتُسوّى مستحقات نهاية الخدمة في كشف رواتب ذلك الشهر.",
    "endedOn": "آخر يوم عمل",
    "endedOnHint": "يُصرف الراتب حتى هذا اليوم.",
    "reason": "السبب",
    "note": "ملاحظة",
    "confirm": "إنهاء الخدمة",
    "toast": "انتهت خدمة {{name}}"
  },
  "documents": {
    "add": "إضافة وثيقة",
    "addTitle": "إضافة وثيقة",
    "edit": "تعديل",
    "editTitle": "تعديل الوثيقة",
    "save": "حفظ الوثيقة",
    "cancel": "إلغاء الوثيقة",
    "cancelTitle": "إلغاء هذه الوثيقة؟",
    "cancelBody": "لا تُحسب الوثيقة الملغاة في متابعة الانتهاء، وتبقى في الملف دون تعديل.",
    "cancelConfirm": "إلغاء الوثيقة",
    "toastAdded": "أضيفت الوثيقة",
    "toastSaved": "حُفظت الوثيقة",
    "toastCancelled": "أُلغيت الوثيقة",
    "empty": "لا توجد وثائق في الملف.",
    "actionsFor": "إجراءات {{type}}",
    "fields": {
      "type": "الوثيقة",
      "number": "الرقم",
      "issuedOn": "تاريخ الإصدار",
      "expiresOn": "تاريخ الانتهاء",
      "issuedBy": "جهة الإصدار",
      "note": "ملاحظة",
      "status": "الحالة"
    }
  },
  "payslips": {
    "period": "الشهر",
    "status": "حالة الكشف",
    "paidDays": "أيام الصرف",
    "gross": "الإجمالي",
    "deductions": "الاستقطاعات",
    "net": "صافي الراتب",
    "empty": "لا توجد قسائم رواتب بعد."
  },
  "history": {
    "effectiveOn": "تاريخ السريان",
    "change": "التغيير",
    "to": "إلى",
    "reason": "السبب",
    "by": "بواسطة",
    "system": "النظام",
    "empty": "لا توجد تغييرات في الحالة بعد."
  },
  "expiryPage": {
    "title": "انتهاء الوثائق",
    "subtitle": "وثائق الموظفين الحاليين المنتهية أو المستحقة، الأقرب أولًا",
    "searchPlaceholder": "الموظف أو رقم الوثيقة",
    "searchLabel": "البحث في الوثائق",
    "fields": {
      "employee": "الموظف"
    },
    "filters": {
      "within": "الانتهاء",
      "type": "الوثيقة",
      "allTypes": "كل الوثائق"
    },
    "empty": {
      "title": "لا شيء قارب على الانتهاء",
      "body": "لا توجد وثيقة منتهية أو مستحقة في هذه المدة."
    }
  },
  "components": {
    "title": "عناصر الراتب",
    "subtitle": "هيكل الرواتب: العناصر التي تتكون منها الرواتب وكشوف الرواتب",
    "add": "إضافة عنصر",
    "addTitle": "إضافة عنصر راتب",
    "edit": "تعديل",
    "editTitle": "تعديل {{code}}",
    "save": "حفظ العنصر",
    "archive": "أرشفة",
    "restore": "استعادة",
    "archived": "مؤرشف",
    "active": "مستخدم",
    "inUse": "في راتب أو كشف رواتب",
    "showArchived": "عرض العناصر المؤرشفة",
    "loadStandard": "تحميل العناصر المعتادة",
    "loadedToast_zero": "لم يُحمّل أي عنصر",
    "loadedToast_one": "حُمّل عنصر واحد",
    "loadedToast_two": "حُمّل عنصران",
    "loadedToast_few": "حُمّلت {{n}} عناصر",
    "loadedToast_many": "حُمّل {{n}} عنصرًا",
    "loadedToast_other": "حُمّل {{n}} عنصر",
    "addedToast": "أضيف {{code}}",
    "savedToast": "حُفظ {{code}}",
    "archivedToast": "أُرشف {{code}}",
    "restoredToast": "استُعيد {{code}}",
    "actionsFor": "إجراءات {{code}}",
    "systemReason": "لا يمكن أرشفة الراتب الأساسي.",
    "systemNote": "يحتفظ الراتب الأساسي برمزه ويبقى ثابتًا: تُحسب عليه الاشتراكات والعمل الإضافي ومكافأة نهاية الخدمة.",
    "inUseNote": "هذا العنصر في راتب أو كشف رواتب: لا يمكن تغيير رمزه أو نوعه.",
    "defaultEarningAccount": "الرواتب والأجور (افتراضي)",
    "defaultDeductionAccount": "استقطاعات رواتب مستحقة (افتراضي)",
    "defaultAccount": "الحساب الافتراضي",
    "accountHintEarning": "فارغ: تُرحّل الاستحقاقات إلى حساب الرواتب والأجور.",
    "accountHintDeduction": "فارغ: تُرحّل الاستقطاعات إلى حساب استقطاعات الرواتب المستحقة.",
    "accountSearch": "ابحث في الحسابات",
    "accountEmpty": "لم يُعثر على حساب",
    "fields": {
      "code": "الرمز",
      "name": "الاسم",
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "kind": "الصنف",
      "type": "النوع",
      "flags": "يدخل في",
      "account": "الحساب",
      "sortOrder": "الترتيب",
      "status": "الحالة"
    },
    "flags": {
      "spf": "أجر الاشتراك",
      "spfHint": "يدخل في الأجر الذي تُحسب عليه اشتراكات الحماية الاجتماعية.",
      "gratuity": "أجر المكافأة",
      "gratuityHint": "يدخل في الأجر الذي تُحسب عليه مكافأة نهاية الخدمة (قانونًا الأجر الأساسي).",
      "prorated": "يُحتسب بالنسبة",
      "proratedHint": "يُصرف عن أيام العمل في شهر التعيين أو المغادرة، وينقص بأيام الغياب دون أجر."
    },
    "empty": {
      "title": "لا توجد عناصر راتب بعد",
      "body": "حمّل العناصر العمانية المعتادة ثم عدّلها."
    }
  },
  "picker": {
    "placeholder": "اختر موظفًا",
    "search": "الرقم أو الاسم أو الرقم المدني",
    "empty": "لم يُعثر على موظف",
    "error": "تعذّر تحميل الموظفين"
  },
  "validation": {
    "nationality": "اختر الجنسية",
    "hours": "أدخل الساعات بخانتين عشريتين على الأكثر",
    "fixedTermEnd": "العقد محدد المدة يحتاج إلى تاريخ انتهاء",
    "endBeforeStart": "ينتهي قبل أن يبدأ",
    "positive": "يجب أن يكون أكبر من صفر",
    "basicRequired": "أدخل الراتب الأساسي",
    "listedTwice": "مكرر",
    "reason": "اختر السبب",
    "expiresBeforeIssued": "تاريخ الانتهاء قبل تاريخ الإصدار",
    "componentCode": "استخدم من 2 إلى 30 حرفًا لاتينيًا أو رقمًا أو شرطة سفلية، يبدأ بحرف"
  },
  "errors": {
    "EMPLOYEE_CIVIL_NUMBER_TAKEN": "لدى موظف حالي آخر الرقم المدني نفسه.",
    "EMPLOYEE_STATUS": "لا يمكن تنفيذ ذلك في حالة الموظف الحالية. أعد تحميل الصفحة لرؤيتها.",
    "EMPLOYEE_DATE_INVALID": "هذا التاريخ غير مناسب: قبل تاريخ التعيين، أو بعيد جدًا، أو في شهر صُرفت رواتبه.",
    "SALARY_DATE_TAKEN": "يبدأ راتب آخر في هذا التاريخ. اختر تاريخًا آخر.",
    "BASIC_REQUIRED": "يحتاج الراتب إلى الراتب الأساسي. حمّل عناصر الراتب المعتادة أولًا.",
    "PAY_COMPONENT_NOT_USABLE": "أحد العناصر مؤرشف أو متغير (العناصر المتغيرة تُدخل في كشف الرواتب لا في الراتب).",
    "PAY_COMPONENT_CODE_TAKEN": "لدى عنصر آخر الرمز نفسه.",
    "PAY_COMPONENT_SYSTEM": "لا يمكن أرشفة الراتب الأساسي أو تغيير رمزه أو جعله متغيرًا.",
    "PAY_COMPONENT_IN_USE": "هذا العنصر في راتب أو كشف رواتب: لا يمكن تغيير رمزه أو نوعه.",
    "DOCUMENT_CANCELLED": "لا يمكن تعديل وثيقة ملغاة.",
    "ORG_UNIT_REQUIRED": "تشمل صلاحيتك جزءًا من الموظفين: اختر وحدة تنظيمية ضمنها.",
    "ORG_UNIT_OUT_OF_SCOPE": "هذه الوحدة التنظيمية خارج الوحدات التي تشملها صلاحيتك. اختر إحدى وحداتك.",
    "EMPLOYEE_USER_TAKEN": "لموظف آخر حساب الدخول نفسه."
  }
}
